<script>
    import { getContext } from 'svelte';
    import { fade, fly } from 'svelte/transition';
    import ModalOverlay from './ModalOverlay.svelte'

    // export let overlayBg = 'rgba(140, 165, 181, 0.8)'
    export let overlayBg = 'rgba(57, 79, 93, 0.8)'
    export let panelBg = '#ffffff'
    export let panelFg = '#4a727f'
    export let classes = ''
    export let hideOverlay = false

    const mobile = getContext ('mobileDevice')
</script>

{#if hideOverlay === false}
    <ModalOverlay {overlayBg} />
{/if}
<div 
    class="ModalPanel {classes}" 
    class:mobile
    style="--panel-bg: {panelBg}; --panel-fg: {panelFg}" 
    in:fly={{ y: 60, duration: 200, delay: 200 }} out:fade={{ duration: 100 }}>
    <div class="fx">
        <slot>
            <div class="basic-panel-content">This is a fallback content</div>
        </slot>
    </div>
</div>


<style>
    .ModalPanel {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 39;
    }
    .ModalPanel :global(.basic-panel-content) {
        width: 400px;
        /* background-color: #fff; */
        background-color: var(--panel-bg);
        color: var(--panel-fg);
        border-radius: 2px;
        padding: 20px;
    }
    .ModalPanel :global(.bx--btn--ghost) {
        color: #fff;
    }
    .ModalPanel :global(.bx--btn--ghost:hover) {
        color: #45575f;
    }

    .ModalPanel.mobile {
        width: 100%;
        top: 50px;
        left: 0;
        height: calc(100% - 50px);
        transform: none;
    }
</style>